var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlgorithm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 3.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 16.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M7.5 3.5h4M7.5 16.5h4M3.5 7.5v5M15.5 7.5v5M5.5 5.5l8 9M5.5 14.5l8-9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorithm);
export default __webpack_public_path__ + "static/media/algorithm.c8f8031350fba9e0169149a8b02688db.svg";
export { ForwardRef as ReactComponent };